<template>
  <div class="text-textColor">
    <transition name="fade">
      <form
          @submit.prevent="create"
      >
        <div
            v-if="showHandover"
            class="bg-black fixed bg-opacity-70 inset-0 z-50 h-screen w-full"
        >
          <div
              class="fixed center-h-v bg-white rounded-md shadow-2xl sm:w-1/2 w-full"
          >
            <div class="flex justify-between items-center border-b-1.5 p-3">
              <p class="text-base">Handover</p>
              <img
                  class="h-6 object-contain cursor-pointer hover:shadow-lg bg-primary rounded-md"
                  src="@/assets/icons/cross-white.png"
                  @click="close()"
              />
            </div>
            <transition name="fade">
              <div
                  v-if="create_error"
                  class="p-1 text-center text-sm w-full bg-yellow-200"
              >
                {{ create_error }}
              </div>
            </transition>
            <transition name="fade">
              <div
                  v-if="create_success"
                  class="p-1 text-center text-white text-sm w-full bg-green-200"
              >
                {{ create_success }}
              </div>
            </transition>
            <div class="container bg-gray-50 rounded p-4 ">
              <h5>Clearance and Resource Collection</h5>
            </div>
            <div class="grid grid-cols-3 p-4 gap-5">
              <div class="text-sm">
                <label class="block pb-1">Item</label>
                <select
                    name=""
                    id=""
                    class="p-2 bg-gray-200 rounded-full w-full"
                    required
                >
                  <option value="" disabled>Select Item</option>

                </select>
              </div>
              <div class="text-sm">
                <label class="block pb-1">Collector</label>
                <select
                    name=""
                    id=""
                    class="p-2 bg-gray-200 rounded-full w-full"
                    required
                >
                  <option value="" disabled>Select Collector</option>

                </select>
              </div>
              <div class="text-sm">
                <label class="block pb-1">Due Date</label>
                <input type="date" class="p-2 bg-gray-200 rounded-full w-full">
              </div>
            </div>

            <div class="flex justify-end p-5">
              <button
                  type="submit"
                  class="bg-primary rounded-full px-10 text-sm text-white py-2"
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      </form>
    </transition>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";

export default {
  name: "Handover",
  props: ["showHandover"],
  data() {
    return {
      selectedType: "single",
      assetType: "",
      condition: "",
      assets: [],
      disciplinaryTypes:[],
      info:{
        DisciplinaryTypeId:'',
        Subject:'',
        Comments:'',
        EmployeeId:'',
        DateTime:'',
        SetupMeeting: false,
        MeetingDetails:''
      },
      create_error: null,
      create_success: null,
    };
  },
  created() {
    this.getDisciplinaryTypes()
    this.info.EmployeeId = this.getCurrentEmployeeId
  },
  computed: {
    ...mapGetters([
      "getOrganization",
      "getToken",
      "getTabTitle",
      "getCurrentEmployeeId",
    ]),
  },
  methods: {
    close() {
      this.$emit("close");
    },
    handleSubmit() {
      setTimeout(() => {
        this.close();
      }, 1000);
    },
    getDisciplinaryTypes() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
          .get(
              `${this.getOrganization}/setup/disciplinary/type/${this.$ApiVersion}/request`,
              options
          )
          .then(
              (response) => {
                this.loading = false;
                if (response.data.StatusCode == 200) {
                  //console.log(response.data.Data);
                  this.disciplinaryTypes = response.data.Data;
                } else {
                  this.get_error = response.data.StatusMessage;
                }
              },
              (error) => {
                this.loading = false;
                this.get_error = error.message;
              }
          );
    },
    create() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          "Content-Type": "application/json",
        },
      };

      axios
          .post(
              `${this.getOrganization}/employee/disciplinary/history/${this.$ApiVersion}/create`,
              JSON.stringify(this.info),
              options
          )
          .then(
              (response) => {
                this.loading = false;
                if (response.data.StatusCode == 200) {
                  this.create_success = response.data.StatusMessage;
                  this.info = {
                    Name: "",
                    Description: "",
                  };
                  setTimeout(() => {
                    this.create_success = null;
                    this.reload();
                    this.close()
                  }, 2500);
                } else {
                  this.create_error = response.data.StatusMessage;
                  setTimeout(() => {
                    this.create_error = null;
                  }, 2500);
                }
              },
              (error) => {
                this.loading = false;
                this.create_error = error.message;
              }
          );
    },
  },
};
</script>

<style scoped>
.center-h-v {
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
</style>
